import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Form, FormLayout } from '@shopify/polaris';
import BasicTextField from '@presentational/BasicTextField';
import { TextField } from '@shopify/polaris';
import { tAttribute } from '@utils';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  // kind: PropTypes.oneOf([ "links", "banners" ]),
}

const defaultProps = {
  // kind: "links"
}

const SectionForm = (props) => {
  // const sharedFieldProps = { handleChange, values, errors }
  return (
    <FormLayout>
      <BasicTextField 
        name="title"
        placeholder="Menu principal, Banners Home"
        label={ tAttribute("general", "title") }
        {...props}
      />
    
      <BasicTextField 
        name="identifier"
        placeholder="section-xxx"
        label={ tAttribute("section", "identifier") }
        {...props}
      />

      <div className="hidden_i">
        <TextField
          id={ "kind" }
          label={ "Kind" }
        />
      </div>
    </FormLayout>
  )
};

SectionForm.propTypes = propTypes;
SectionForm.defaultProps = defaultProps;

export default SectionForm;